module.exports = __webpack_public_path__ + "static/chillter-logo-15e2fa469a9df7346f72749a70e08b1f.png";